const truncateText = (value, maxLength = 1200) => {
  if (typeof value !== 'string') return null;
  const normalized = value.replace(/\s+/g, ' ').trim();
  if (!normalized) return null;
  return normalized.length > maxLength
    ? `${normalized.slice(0, maxLength)}...`
    : normalized;
};

const summarizeRequestData = (requestData = {}) => {
  const inputAssets = Array.isArray(requestData.inputAssets) ? requestData.inputAssets : [];

  return {
    clientTaskKey: requestData.clientTaskKey || null,
    modelName: requestData.modelName || null,
    modelKey: requestData.modelKey || null,
    functionMode: requestData.functionMode || null,
    generationMode: requestData.generationMode || null,
    size: requestData.size || null,
    resolutionLabel: requestData.resolutionLabel || null,
    aspectRatioLabel: requestData.aspectRatioLabel || null,
    duration: Number.isFinite(Number(requestData.duration)) ? Number(requestData.duration) : null,
    generateAudio: requestData.generateAudio === true,
    outputCount: Number.isFinite(Number(requestData.outputCount)) ? Number(requestData.outputCount) : null,
    inputAssetCount: inputAssets.length,
    inputAssetTypes: inputAssets.map((asset) => asset?.type || 'unknown'),
    imageUrlCount: Array.isArray(requestData.imageUrl)
      ? requestData.imageUrl.length
      : requestData.imageUrl
        ? 1
        : 0,
    riskContext: requestData.riskContext || null,
  };
};

const getRuntimeContext = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return null;
  }

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  return {
    href: truncateText(window.location?.href || '', 500),
    pathname: window.location?.pathname || null,
    language: navigator.language || null,
    languages: Array.isArray(navigator.languages) ? navigator.languages.slice(0, 5) : null,
    online: typeof navigator.onLine === 'boolean' ? navigator.onLine : null,
    userAgent: truncateText(navigator.userAgent || '', 500),
    platform: navigator.platform || null,
    viewport: {
      width: Number(window.innerWidth || 0) || null,
      height: Number(window.innerHeight || 0) || null,
      dpr: Number(window.devicePixelRatio || 1) || 1,
    },
    connection: connection
      ? {
          effectiveType: connection.effectiveType || null,
          downlink: Number.isFinite(Number(connection.downlink)) ? Number(connection.downlink) : null,
          rtt: Number.isFinite(Number(connection.rtt)) ? Number(connection.rtt) : null,
          saveData: typeof connection.saveData === 'boolean' ? connection.saveData : null,
        }
      : null,
  };
};

export async function reportGenerationClientFailure({
  apiEndpoint,
  requestData,
  stage,
  responseStatus = 0,
  responseText = '',
  responseContentType = '',
  normalizedError = null,
  rawError = null,
}) {
  if (typeof window === 'undefined') return;

  const payload = {
    sourceEndpoint: apiEndpoint || null,
    stage: stage || 'unknown',
    responseStatus: Number.isFinite(Number(responseStatus)) ? Number(responseStatus) : 0,
    responseContentType: responseContentType || null,
    normalizedCode: normalizedError?.code || null,
    normalizedMessage: normalizedError?.message || null,
    rawMessage:
      truncateText(rawError?.message || rawError?.rawMessage || normalizedError?.rawMessage || '', 1200)
      || null,
    responseTextPreview: truncateText(responseText, 1200),
    requestSummary: summarizeRequestData(requestData),
    runtimeContext: getRuntimeContext(),
    clientReportedAt: new Date().toISOString(),
  };

  try {
    await fetch('/api/generation/client-failure', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (error) {
    console.warn('[generation-client-failure] failed to report client diagnostic', error);
  }
}
